import NotificationsContainer from './notifications_container';

const Notifications = NotificationsContainer;
export default Notifications;
